const SET_PAGE = 'SET_PAGE';

const REDUCER_ACTIONS = {
  SET_PAGE,
}
export default REDUCER_ACTIONS;
